import apiService from "./ApiService";
import { ApiEndpoints } from "./ApiConstants";

export const getTeams = (page = 0) => {
    return apiService
        .get(ApiEndpoints.GET_TEAMS, { params: { page } })
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getLastOutcome = (teamId, count = 5) => {
    return apiService
        .get(`${ApiEndpoints.GET_LAST_OUTCOME}/${teamId}`, { params: { count } })
        .then((response) => response.data)
        .catch((error) => error.response);
};